import { CircularProgress, Stack } from '@mui/material';
import { useState } from 'react';
import Typewriter from 'typewriter-effect';
import InteractionModel, { InteractionAuthor } from "../data/InteractionModel";
import { months } from '../data/months';

export type FormYearMonthProps = {
  onSubmit: (yearMonth: string) => any;
  question: string;
  lastAnswer: string | number;
  interactions?: InteractionModel[] | undefined;
  loading?: boolean | undefined;
}

const years = Array.from({ length: new Date().getFullYear() - 1899 }, (_, index) => index + 1900).reverse();

export default function FormYearMonth(props: FormYearMonthProps) {

  const { loading = false } = props;

  const [month, setMonth] = useState('');
  const [year, setYear] = useState('');


  function handleSubmit() {
    const yearMonth = year + '-' + (month.length < 2 ? '0' : '') + month;
    props.onSubmit(yearMonth);
  }


  return (
    <>
      <div className="chat-container">

        <div className="chat">
          <div className="container">
            <div className="row">
              <div className="col-12 d-flex flex-column align-items-stretch justify-content-between">

                { props.lastAnswer !== undefined && (
                  <div className="chat-item chat-item-user">
                    <img src="images/ico-chat-user.svg" alt="Usuário" />
                    <div className="chat-item-content">
                      <p>
                        { props.lastAnswer }
                      </p>
                    </div>
                  </div>
                ) }

                <div className="chat-item">
                  <img src="images/ico-chat-amarelinho.svg" alt="Amarelinho" />
                  <div className="chat-item-content">
                    <Typewriter
                      onInit={ (typewriter) => {
                        typewriter.changeDelay(15).typeString(props.question)
                          .start();
                      } } />
                  </div>
                </div>

                {
                  props.interactions !== undefined && props.interactions.map((interaction, index) => {
                    let objRet;

                    if (interaction.author === InteractionAuthor.AMARELINHO) {
                      objRet = <div className="chat-item" key={ index + interaction.text }>
                        <img src="images/ico-chat-amarelinho.svg" alt="Amarelinho" />
                        <div className="chat-item-content">
                          <Typewriter
                            onInit={ (typewriter) => {
                              typewriter.changeDelay(15).typeString(interaction.text)
                                .start();
                            } } />
                        </div>
                      </div>

                    } else if (interaction.author === InteractionAuthor.CLIENTE) {
                      objRet = <div className="chat-item chat-item-user" key={ index + interaction.text }>
                        <img src="images/ico-chat-user.svg" alt="Usuário" />
                        <div className="chat-item-content">
                          <p>{ interaction.text }</p>
                        </div>
                      </div>
                    }

                    return objRet;
                  })
                }

              </div>
            </div>
          </div>
        </div>

        <footer className="footer-answer">
          <div className="container">
            <div className="row">
              <div className="col-12">
                <div className="footer-answer-holder d-flex align-items-center justify-content-between">

                  { loading &&
                    <Stack sx={ { color: '#6F5192' } } justifyContent="center" alignItems="center">
                      <CircularProgress color="inherit" />
                    </Stack>
                  }

                  { !loading && (
                    <>
                      <div className="d-flex align-items-center">
                        <div className="field">
                          <select className="input-container" name="month" value={ month } onChange={ e => setMonth(e.currentTarget.value) }>
                            <option value="" disabled>mês</option>
                            { months.map((monthText, index) => (
                              <option key={ monthText } value={ index + 1 }>{ monthText }</option>
                            )) }
                          </select>
                        </div>
                        <span>de</span>
                        <div className="field">

                          <select className="input-container" name="month" value={ year } onChange={ e => setYear(e.currentTarget.value) }>
                            <option value="" disabled>ano</option>
                            { years.map((yearValue) => (
                              <option key={ yearValue } value={ yearValue }>{ yearValue }</option>
                            )) }
                          </select>
                        </div>
                      </div>

                      <button type="button" className="btn-submit" onClick={ handleSubmit }>
                        <svg width="24" height="20" viewBox="0 0 24 20" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M0.0114286 20L24 10L0.0114286 0L0 7.77778L17.1429 10L0 12.2222L0.0114286 20Z"></path></svg>
                      </button></>
                  ) }
                </div>
              </div>
            </div>
          </div>
        </footer>
      </div>
    </>);
}
